import * as React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { LiabilityEntityIndex } from '@funnels/types';
import { validateExclusiveNumberRanges, validateInclusiveNumberRanges } from '@funnels/utils';

import { NumeralDisplay, PercentageInputField } from '../../Fields';
import { EditableViewProps, NumericalReadOnlyViewProps } from '../types';

interface CurrentInterestRateFunnelViewProps extends LiabilityEntityIndex {
  label?: string;
  isOptional?: boolean;
  isZeroValid?: boolean;
}
export const CurrentInterestRateFunnelView = (props: CurrentInterestRateFunnelViewProps) => {
  const { isOptional, label, liabilityIndex, isZeroValid } = props;

  return (
    <PercentageInputField
      {...props}
      name={FIELD_PATHS.LIABILITY_INTEREST_RATE(liabilityIndex)}
      label={label}
      isOptional={isOptional}
      isZeroValid={isZeroValid}
      validate={
        isZeroValid
          ? validateInclusiveNumberRanges(0, 99.99, isOptional)
          : validateExclusiveNumberRanges(0, 100, isOptional)
      }
    />
  );
};

export const CurrentInterestRateReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay after={'%'} {...props} />
);

interface CurrentInterestRateEditableViewProps extends EditableViewProps, LiabilityEntityIndex {
  label?: string;
  disableFailMessage?: boolean;
  isZeroValid?: boolean;
  validationFailMessage?: string;
}

export const CurrentInterestRateEditableView = (props: CurrentInterestRateEditableViewProps) => (
  <PercentageInputField
    name={FIELD_PATHS.LIABILITY_INTEREST_RATE(props.liabilityIndex)}
    label={props.label}
    isOptional={props.isOptional}
    isDisabled={props.isDisabled}
    disableFailMessage={props.disableFailMessage}
    isZeroValid={props.isZeroValid}
    validate={
      props.isZeroValid
        ? validateInclusiveNumberRanges(0, 99.99, props.isOptional, props.validationFailMessage)
        : validateExclusiveNumberRanges(0, 100, props.isOptional, props.validationFailMessage)
    }
  />
);
